import React from "react";

function baseIcon(children) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {children}
        </svg>
    );
}

export function CreateNoteIcon() {
    return baseIcon(
        <>
            <path d="M9 4.5h6l3 3V18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2Z" />
            <path d="M15 4.5v3h3" />
            <path d="M12 10v5" />
            <path d="M9.5 12.5h5" />
        </>
    );
}

export function EditNoteIcon() {
    return baseIcon(
        <>
            <path d="M8 4.5h6l3 3V18a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2Z" />
            <path d="M14 4.5v3h3" />
            <path d="m10 15.8 5.8-5.8 2 2L12 17.8l-2.6.6z" />
        </>
    );
}

export function PreviewNoteIcon() {
    return baseIcon(
        <>
            <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
            <circle cx="12" cy="12" r="3.25" />
        </>
    );
}

export function MetricsIcon() {
    return baseIcon(
        <>
            <path d="M4.5 19.5h15" />
            <path d="M7 18V11.5" />
            <path d="M12 18V8.5" />
            <path d="M17 18V5.5" />
            <path d="m6.5 8.5 4.1-3 3.1 1.6 3.8-3.1" />
        </>
    );
}

export function EditHomeIcon() {
    return baseIcon(
        <>
            <rect x="4" y="4" width="6" height="6" rx="1.2" />
            <rect x="14" y="4" width="6" height="6" rx="1.2" />
            <rect x="4" y="14" width="6" height="6" rx="1.2" />
            <rect x="14" y="14" width="6" height="6" rx="1.2" />
        </>
    );
}
